import { styled, Typography } from '@mui/material';
import { SignatureImage } from '../../../components/SignatureImage';

function EsajSignature() {
    return (
        <Row>
            <Column>
                <Typography>Signature du responsable financer</Typography>
                <Typography>Monsieur Sacha Lenzini</Typography>
                <Typography>Directeur de l’ésaj</Typography>
            </Column>
            <SignatureImage
                src="https://res.cloudinary.com/dsbb0ado2/image/upload/v1752173657/signature-esaj_dsk3f0.png"
                alt="signature du responsable financier de l'esaj"
            />
        </Row>
    );
}

const Column = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
}));

const Row = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
}));

export { EsajSignature };
